/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, April 2021
 * @format
 * @flow
 */

import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import strings from '../../globalization';
import styles from './InactivityPopup.module.css';

const InactivityPopup = props => {
  const [timer, setTimer] = useState(30);
  const intervalRef = useRef(null);
  const { closePopup, onAction, showLogout } = props;

  useEffect(() => {
    startTimer();
    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  const startTimer = () => {
    clearInterval(intervalRef.current);
    let newTimer = 30;
    setTimer(newTimer);
    intervalRef.current = setInterval(() => {
      if (newTimer <= 0) {
        onPressLogout();
        return;
      }
      newTimer--;
      setTimer(newTimer);
    }, 1000);
  };

  const onPressLogout = () => {
    onAction && onAction();
  };

  const onPressCancel = () => {
    closePopup && closePopup();
  };

  return (
    <div className={styles.modalView}>
      <div className={styles.headingWrapper}>
        <div className={styles.headingTxt}>{'Alert'}</div>
      </div>
      <div className={styles.bodyWrapper}>
        <div className={styles.contentTxt}>{strings.inactivityMsg} {timer} {strings.seconds}.</div>
      </div>
      <div className={styles.footerWrapper}>
        {!showLogout ? null :
          <button className={styles.btn} onClick={onPressLogout}>
            <div className={styles.btnTxt}>{strings.logout.toUpperCase()}</div>
          </button>
        }
        <button className={styles.btn} onClick={onPressCancel}>
          <div className={styles.btnTxt}>{strings.iAmStillHere.toUpperCase()}</div>
        </button>
      </div>
    </div>
  );
};

export default InactivityPopup;

InactivityPopup.propTypes = {
  showLogout: PropTypes.bool,
  onAction: PropTypes.func,
  closePopup: PropTypes.func.isRequired,
};

InactivityPopup.defaultProps = {
  showLogout: false,
};
